import { COMPARATOR_URL } from '../common/constants/constants';
import { log } from '../utils/console';
import {
  MAX_COMPARATOR_ITEMS,
  getStorageComparatorName,
  comparator,
} from '@pes-ui/components/dist/collection/globals/common/comparator';

export class ComparatorAPI {
  actionCallBack = null;

  // region async storage listen and react

  startListen = () => {
    window.addEventListener('storage', this.executeSync);
  };

  stopListen = () => {
    window.removeEventListener('storage', this.executeSync);
  };

  executeSync = (event) => {
    if (event.key !== getStorageComparatorName()) {
      return;
    }

    this.injectCompareProducts();
  };

  // endregion

  get maxQty() {
    return MAX_COMPARATOR_ITEMS;
  }

  get comparatorUrl() {
    return COMPARATOR_URL;
  }

  setActionCallBack(actionCallBack) {
    this.actionCallBack = actionCallBack;
    this.injectCompareProducts();
    this.startListen();
  }

  injectCompareProducts() {
    if (!this.actionCallBack) {
      log.warn('Required @action callback to sync data');
      return;
    }

    this.actionCallBack(this.getStoredProductIds());
  }

  add(skuObj) {
    if (comparator.isFull()) {
      comparator.notifySubscribers();
      
      return;
    }

    comparator.add(skuObj.productId);
    this.injectCompareProducts();
    comparator.notifySubscribers();
  }

  remove(skuID) {
    comparator.remove(skuID);
    this.injectCompareProducts();
    comparator.notifySubscribers();
  }

  getStoredProductIds() {
    return comparator.getStoredProductIds();
  }
}
